<div class="login-prompt-container">
  <div class="login-prompt-header">
    <button
      mat-icon-button
      class="login-prompt-close"
      (click)="onClose()"
      [attr.aria-label]="'LOGIN_PROMPT.CLOSE_ARIA_LABEL' | translate"
    >
      <mat-icon svgIcon="close"></mat-icon>
    </button>
  </div>

  <h2 class="login-prompt-title">{{ "LOGIN_PROMPT.TITLE" | translate }}</h2>

  <div class="login-prompt-description">
    <p>{{ "LOGIN_PROMPT.VAULT_NOTICE" | translate }}</p>
    <p>{{ "LOGIN_PROMPT.LOGIN_REQUIRED" | translate }}</p>
    <p *ngIf="showOvernightCopy" class="login-prompt-description__overnight">
      {{ "LOGIN_PROMPT.OVERNIGHT_PREFIX" | translate
      }}<span class="login-prompt-description__emphasis">{{
        "LOGIN_PROMPT.OVERNIGHT_LABEL" | translate
      }}</span
      >{{ "LOGIN_PROMPT.OVERNIGHT_MIDDLE" | translate }}
      <span class="login-prompt-description__deadline">{{
        confirmationDeadline
      }}</span>
    </p>
    <p *ngIf="showOvernightCopy">
      {{ "LOGIN_PROMPT.RATE_PROTECTED" | translate }}
    </p>
  </div>

  <div class="login-prompt-actions">
    <div class="login-prompt-actions__row">
      <button
        mat-raised-button
        class="login-prompt-button login-prompt-button--primary"
        (click)="onLogin()"
      >
        {{ "LOGIN_PROMPT.LOGIN_BUTTON" | translate }}
      </button>
      <button
        mat-stroked-button
        class="login-prompt-button login-prompt-button--secondary"
        (click)="onCreateAccount()"
      >
        {{ "LOGIN_PROMPT.CREATE_ACCOUNT" | translate }}
      </button>
    </div>
  </div>
</div>
